import React, { Component } from 'react';
import FakeData from '.././fake-data';
import { Link } from 'react-router-dom';
import SettingContext from './SettingContext';

import Geosuggest from 'react-geosuggest';

import { CountryDropdown, RegionDropdown } from 'react-country-region-selector';

import './Settings.css';
import { Modal, ComboBox, PublicityPicker, PhonePicker, ConfirmModal, ItemPicker, EmptyState, LoadingState, InputField } from './Common';
import Avatar from './Avatar'
import { SplitPane } from './Teams'
import { EventViewSplitPane } from './Event';
import RichTextInputField from "./RichTextInputField";
import MD5 from './md5';
import SHA1 from './SHA1';

export default class Settings extends Component {
    constructor(props) {
        super(props);
        let _settings = FakeData.listify(props.settings).filter((item, i)=>{
            return !FakeData.inArray(item,["Post Attribution","Page Roles","Videos","SPAM"]);
        })

        _settings.push("Blocking")
        this.state = {
            activeTab: props.type==="F"?"Security":_settings[0],
            userTabs: props.type==="F"?[/*"General", */"Security", "Privacy", "Timeline & Tagging", "Blocking", "Notifcations"]:_settings,
        }
    }

    getSettings = (cat) => {
        return FakeData.listify(this.props.profile.settings).filter((item,i)=>{
            return item.cat === cat;
        })
    }

    render() {
        const {profile} = this.props;
        const { activeTab, userTabs } = this.state
        const SettingsObject = this.getSettings(activeTab)
        return (
            <div className="default-view" style={{ backgroundColor: "#fff", paddingBottom: "20px" }}>
                <EventViewSplitPane isExtended="true" active={this.state.activeTab} items={userTabs} setView={(d) => {
                    this.setState({
                        activeTab: d
                    });
                }}>
                    {activeTab!=="Blocking" && <EmptyState isShown={(SettingContext[this.props.type][activeTab].length === 0) ? true : false} text="No settings were found!" icon="settings" />}
                    {activeTab!=="Blocking" && <SettingList settings={SettingsObject} cat={activeTab} settingsFields={SettingContext[this.props.type][activeTab]} userType={this.props.type} profile={profile}/>}
                    {activeTab==="Blocking" &&<Blocking userType={this.props.type} userId={profile.id} profile={profile} />}
                </EventViewSplitPane>
            </div>
        );
    }
}

class Blocking extends Component{
    constructor(p){
        super(p)
        this.state = {
            list : []
        }
    }

    componentDidMount(){
        this._isMounted = true;
        this.getData();
    }

    componentWillUnmount(){
        this._isMounted = false;
    }

    getData = () => {
        const _that = this;
        const _data = {
            id: _that.props.userId,
            type: _that.props.userType
        }

        FakeData.post(FakeData.apiURL+"/admin/block/list", _data, {
            headers: {
                'Content-Type': 'application/json'
            },
            method: "POST",
            success(res) {
                if(!_that._isMounted){
                    return;
                }
                _that.setState({ list: res });
            },
            error(error) {
                if(!_that._isMounted){
                    return;
                }
                _that.setState({ list: [] });
            }
        })
    }

    unblock = (id, string) => {
        const _unblock = window.confirm(string==="show account posts"?`Are you sure you want to ${string} again?`:`Are you sure you want to ${string} this content?`);
        const _that = this;
        if(!_unblock){
            return;
        }

        FakeData.post(FakeData.apiURL+"/admin/unblock/"+id, {}, {
            headers: {
                'Content-Type': 'application/json'
            },
            method: "POST",
            success(res) {
                if(!_that._isMounted){
                    return;
                }
                _that.getData();
            },
            error(error) {
                if(!_that._isMounted){
                    return;
                }
            }
        }, true, "", null)
    }

    render = () => {
        const {list} = this.state;
        const {} = this.props;
        return(
            <div className={"setting-list"} style={{ width: "100%" }}>
                <EmptyState isShown={(list.length === 0) ? true : false} text="No blocked content!" icon="settings" />
                {
                    [
                        {label:"People",type:["F"]},
                        {label:"Pages",type:["C","T","I","L"]},
                        {label:"Posts",type:["post","game-post"]},
                        {label:"Messages",type:["chat"]},
                        {label:"Videos",type:["video","photo"]}
                    ].map((item, i)=>{
                        const _list = list.filter((_item, _i)=>{
                            return FakeData.inArray(_item.user_type, item.type)
                        })

                        if(_list.length === 0){
                            return null
                        }
                        return(
                            <div key={i} className={"setting-list-item"}>
                                <span><strong>{item.label}</strong></span>
                                <div>
                                    <EmptyState isShown={(_list.length === 0) ? true : false} text="No blocked content!" icon="settings" />
                                    {_list.length > 0 &&
                                        _list.map((conf, x)=>{
                                            return(
                                                <BlockObject conf={conf} key={conf.user_type+x} unblock={this.unblock.bind(this)}/>
                                            )
                                        })
                                    }
                                </div>
                            </div>
                        )
                    })
                }
            </div>
        )
    }
}

export const BlockObject = ({conf, unblock, isAdmin, isSupport,...props}) => {
    if(conf.object.error){
        return null
    }
    return(
        <div className={"block-list-item"} style={{
            marginBottom: isSupport?"0px":""
        }}>
            {conf.object.image && <img src={conf.object.image} />}
            {!conf.object.image && <div className="img" style={{
                color: "#fff",
                background: "#345"
            }}>{conf.user_type}</div>}
            <div className={"block-list-item-info"}>
                <span>
                    {conf.object.content}
                </span>
                <button onClick={() => {
                    unblock(conf._id, (conf.type === "block" ? "unblock" : conf.type === "unfollow" ? "show account posts" : "unhide"))
                }}>{conf.type === "block" ? "Unblock" : conf.type === "unfollow" ? "Show Posts" : "Unhide"}</button>
            </div>
        </div>
    )
}

class SettingList extends Component{
    constructor(p){
        super(p)
        this.state = {
            
        }
    }

    render(){
        const {profile, settings, settingsFields} = this.props;
        if(settings.length === 0){
            //return null
        }
        return(
            <div className={"setting-list"} style={{ width: "100%" }}>
                {
                    FakeData.listify(settingsFields).map((item, i)=>{
                        return(
                            <div key={i} className={"setting-list-item"}>
                                <span><strong>{item.name}</strong></span>
                                <div>
                                    {
                                        FakeData.listify(item.config).map((conf, x)=>{
                                            return(
                                                <SettingListItem userType={this.props.userType} cat={this.props.cat} key={x} profileSettings={settings} settings={conf} profile={profile} />
                                            )
                                        })
                                    }
                                </div>
                            </div>
                        )
                    })
                }
            </div>
        )
    }
}

class SettingListItem extends Component{
    constructor(p){
        super(p)
        this.state = {
            isEdit: false,
            token: Date.now(),
            content: {
                change_pass_curr_error: true,
                change_pass_error: false,
                change_re_pass_error: false,
                change_pass_curr: "",
                change_re_pass: "",
                change_pass: ""
            }
        }
    }

    save(setting, input_type, arrString, last = false){
        const _that = this;
        const {profile, settings, userType, cat} = this.props;
        if(!last){
            this.saveSync(setting, input_type, arrString);
            return;
        }
        const _data = {
            userId: profile.id,
            userType,
            cat,
            setting,
            setting_types: arrString.split(","),
            input_type
        }

        //console.log(_data)
        //TODO

        FakeData.post("/saveSettings.php?auth0", _data, {
            success(res){
                
            }
        })
    }

    saveSync = (setting, input_type, arrString) => {
        const _that = this;
        const {profile, settings, userType, cat} = this.props;

        const _data = {
            userId: profile.id,
            userType,
            cat,
            setting,
            setting_types: arrString.split(","),
            input_type
        }

        //console.log(_data)
        //TODO

        FakeData.post(FakeData.apiURL+"/api/settings/create", _data, {
            headers: {
                'Content-Type':'application/json'
            },
            success(res){
                alert("Saved!");
                _that.setState({ 
                token: Date.now(), 
                content: {
                    change_pass_curr_error: true,
                    change_pass_error: false,
                    change_re_pass_error: false,
                    change_pass_curr: "",
                    change_re_pass: "",
                    change_pass: ""
                }});
                _that.save(setting, input_type, arrString, true)
            }
        }, true, "", null)
    }

    changePassword(){
        const _that = this;
        const {profile} = this.props;

        const _data = {
            user: profile,
            pass_word: this.state.content.change_pass,
            password: SHA1(this.state.content.change_pass)
        }

        //console.log(_data)

        FakeData.post("/changePassword.php?auth0", _data, {
            success(res){
                alert("Saved!");
                _that.state.content.change_pass_curr = "",
                _that.state.content.change_re_pass = "",
                _that.state.content.change_pass = ""
                _that.setState({ token: Date.now(), content: _that.state.content });
            }
        }, true, "", null)
    }

    getSettingValue = (tag, cat, type, fallbackValue) => {
        const settings = this.props.profileSettings.filter((item,i)=>{
            return item.cat === cat && item.type === type && FakeData.inArray(item.sub, tag.split(","));
        });
        const {profile} = this.props;
        if(FakeData.inArray(tag, ["page_verification"])){
            return profile.isVerified
        } else if(settings.length === 0){
            return fallbackValue;
        } else{
            return settings[0]['value']
        }
    }
    
    render(){
        const {profile, settings, userType} = this.props;
        const {isEdit, token} = this.state;
        return(
            <div className={"setting-item-ctx"}>
                <div className={"setting-item-ctx-body"}>
                    {settings.selfExpand && <span style={{marginBottom: isEdit?"15px":"",display: "block", cursor: "pointer"}} onClick={()=>{this.setState({ isEdit: !isEdit });}}><strong>{settings.desc}</strong></span>}
                    {!settings.selfExpand && <span style={{marginBottom: isEdit?"15px":"",display: "block"}} dangerouslySetInnerHTML={{__html:settings.desc}}></span>}
                    {settings.rules && isEdit && 
                        <ul style={{marginBottom: isEdit?"15px":""}}>
                            {
                                settings.rules.map((rule, r)=>{
                                    return(
                                        <li key={r+rule}>{rule}</li>
                                    )
                                })
                            }
                        </ul>
                    }
                    {isEdit &&
                        <div className="setting-item-ctx-body-item">
                        {
                            FakeData.listify(settings.settings).map((item,i)=>{
                                return(
                                    <div key={i+item.desc+item.subDesc} className="setting-item-ctx-body-item-desc" style={{
                                        flexDirection: (item.action==="select" || item.action==="button" || item.action ==="field" || item.action ==="change-password")?"column":"",
                                        flexWrap: (item.hasAction)?"wrap":""
                                    }}>
                                        <div>
                                            <span className="setting-item-ctx-body-item-desc-title" dangerouslySetInnerHTML={{__html:this.getSettingValue(item.tag,this.props.cat,item.action, item.default)?(item.descIf?item.descIf:item.desc):item.desc}}></span>
                                            {item.subDesc && <span className="setting-item-ctx-body-item-desc-sub-title" dangerouslySetInnerHTML={{__html:item.subDesc}}></span>}
                                        </div>
                                        {item.action === "switch" &&
                                            <label className="switch">
                                                <input disabled={item.readOnly} checked={this.getSettingValue(item.tag,this.props.cat,item.action, item.default)} type="checkbox" onChange={(e)=>{
                                                    this.save(e.target.checked, "switch",item.tag );
                                                }} />
                                                <span className="slider round new"></span>
                                            </label>
                                        }
                                        {item.action === "change-password" && 
                                        <div className="setting-switch-list">
                                            <InputField label={"Current Password"}>
                                                <input type="password" className={this.state.content['change_pass_curr_error']?"error":""} value={this.state.content['change_pass_curr']} placeholder="current password" onChange={(e)=>{
                                                    this.state.content['change_pass_curr_error'] = (profile.hash_key === SHA1(e.target.value))?false : true;
                                                    this.state.content['change_pass_curr'] = e.target.value;
                                                    this.setState({ content: this.state.content });
                                                }}/>
                                            </InputField>
                                            <InputField label={"New Password"}>
                                            <input type="password" className={this.state.content['change_pass_error']?"error":""} value={this.state.content['change_pass']} placeholder="current password" onChange={(e)=>{
                                                    this.state.content['change_pass_error'] = (e.target.value.length >= 7)?false : true;
                                                    this.state.content['change_pass'] = e.target.value;
                                                    this.setState({ content: this.state.content });
                                                }}/>
                                            </InputField>
                                            <InputField label={"Repeat New Password"}>
                                            <input type="password" className={this.state.content['change_re_pass_error']?"error":""} value={this.state.content['change_re_pass']} placeholder="repeat password" onChange={(e)=>{
                                                    this.state.content['change_re_pass_error'] = (e.target.value === this.state.content['change_pass'])?false : true;
                                                    this.state.content['change_re_pass'] = e.target.value;
                                                    this.setState({ content: this.state.content });
                                                }}/>
                                            </InputField>
                                            <button className="button" onClick={()=>{
                                                this.changePassword();
                                            }} disabled={this.state.content.change_pass_curr_error || !(this.state.content.change_pass.length > 6 && (this.state.content.change_pass === this.state.content.change_re_pass))}>Change Password</button>
                                        </div>
                                        }
                                        {item.action === "switches" &&
                                            <div className="setting-switch-list">
                                                {
                                                    FakeData.listify(item.options).map((opt, o)=>{
                                                        return(
                                                            <div key={o+opt.label} className="setting-switch-list-item">
                                                                <span>{opt.label}</span>
                                                                <label className="switch">
                                                                    <input disabled={opt.readOnly} type="checkbox" checked={this.getSettingValue(opt.tag,this.props.cat,item.action, opt.default)} onChange={(e)=>{
                                                                        this.save(e.target.checked, "switches",opt.tag );
                                                                    }} />
                                                                    <span className="slider round new"></span>
                                                                </label>
                                                            </div>
                                                        )
                                                    })
                                                }
                                            </div>
                                        }
                                        {item.action==="select" && 
                                            <select disabled={item.readOnly} value={this.getSettingValue(item.tag,this.props.cat,item.action, item.default)} onChange={(e)=>{
                                                this.save(e.target.value, "select",item.tag );
                                            }}>
                                                {
                                                    item.options.map((opt, op)=>{
                                                        return(
                                                            <option key={op+opt+op} value={opt}>{item.tag==="age_restriction"?"Anyone ("+opt+" +)":opt}</option>
                                                        )
                                                    })
                                                }
                                            </select>
                                        }
                                        {item.action==="button" && 
                                            <button className={"button"}>{item.btnTxt}</button>
                                        }
                                        {item.action==="field" && !item.isPlainField && 
                                            <RichTextInputField textAreaStyle={{
                                                width: "100%"
                                            }} onRawTextChange={(text, rawText)=>{
                                                this.state.content[item.tag.replace(",","_")+'_rawContent'] = rawText;
                                                this.state.content[item.tag.replace(",","_")+'_content'] = text;
                                                this.setState({content: this.state.content});
                                              }} usersOnly={true} placeholder={""} key={token} value={this.getSettingValue(item.tag,this.props.cat,item.action, item.default)} onTextChange={(e) => {}}/>
                                        }
                                        {item.action==="field" && item.isPlainField &&
                                            <textarea ref={(ref)=>{
                                                if(!this.state.content[item.tag.replace(",","_")+'_rawContent']){
                                                    this.state.content[item.tag.replace(",","_")+'_rawContent'] = this.getSettingValue(item.tag,this.props.cat,item.action, item.default);
                                                    this.state.content[item.tag.replace(",","_")+'_content'] = this.getSettingValue(item.tag,this.props.cat,item.action, item.default)
                                                    this.setState({content: this.state.content});
                                                }
                                            }} value={this.state.content[item.tag.replace(",","_")+'_rawContent']} onChange={(e) => {
                                                this.state.content[item.tag.replace(",","_")+'_rawContent'] = e.target.value;
                                                this.state.content[item.tag.replace(",","_")+'_content'] = e.target.value;
                                                this.setState({content: this.state.content});
                                            }} />
                                        }
                                        {item.action==="field" && item.isPlainField &&
                                            <div style={{
                                                marginTop: 10
                                            }} onClick={()=>{
                                                
                                            }}>
                                                {
                                                    this.getSettingValue(item.tag,this.props.cat,item.action, item.default).split(",").map((item,i)=>{
                                                        return(
                                                            <code key={i} style={{
                                                                marginRight: 10
                                                            }}>{item}</code>
                                                        )
                                                    })
                                                }
                                            </div>
                                        }
                                        {item.action==="field" && 
                                            <button className={"button"} onClick={()=>{
                                                this.save(this.state.content[item.tag.replace(",","_")+'_rawContent'], "field",item.tag );
                                            }}>SAVE</button>
                                        }
                                        {item.hasAction && !this.getSettingValue(item.tag,this.props.cat,item.action, item.default) &&
                                            <button style={{
                                                width: "100%"
                                            }} className={"button"} onClick={()=>{
                                                item.actionButton.onClick(userType, profile.id)
                                            }}>{item.actionButton.text}</button>
                                        }
                                    </div>
                                )
                        })
                        }
                        </div>
                    }
                </div>
                {!settings.textOnly && <i onClick={()=>{this.setState({ isEdit: !isEdit });}} className="material-icons">edit</i>}
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/Settings.js